
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import MediaTab from './components/MediaTab';
import browserDetect from '@/lib/vendor/browserDetect';

const COLLAGE_POPUP_PER = 30;

export default {
  i18nComponentKey: 'ProductReviewsMediaCollage.ProductReviewsMediaCollageMobile',
  name: 'ProductReviewsMediaCollageMobile',
  components: { MediaTab },
  data: function() {
    return {
      scrollPosition: 0
    };
  },
  computed: {
    ...mapState(['sort']),
    ...mapState('productMediaReviewCollage', [
      'isLoadingMediaReviewCollage',
      'totalMediaCount',
      'pagy',
      'reviews',
      'activeTab'
    ]),
    ...mapState('window', ['windowService']),
    ...mapGetters('productMediaReviewCollage', ['reviewMedia']),
    ...mapGetters('reviewSettings', ['isVideoUploadable']),
    ...mapGetters('widget', ['reviewPopupUrl'])
  },
  mounted() {
    this.fetchResource({ init: true });
  },
  methods: {
    ...mapActions('productMediaReviewCollage', [
      'fetchProductMediaReviewCollage'
    ]),
    ...mapMutations('productMediaReviewCollage', ['SET_ACTIVE_TAB']),
    async fetchResource(params) {
      // HACK: iOS Safari에서 스크롤 위치를 기억하여 페이지 이동 후 복원
      if (params.page && browserDetect.isIOS) {
        this.scrollPosition =
          window.scrollY || document.documentElement.scrollTop;
      }

      await this.fetchProductMediaReviewCollage({
        ...params,
        per: COLLAGE_POPUP_PER
      });

      // HACK: iOS Safari에서 스크롤 위치를 기억하여 페이지 이동 후 복원
      if (params.page && browserDetect.isIOS) {
        this.$nextTick(() => {
          window.scrollTo(0, this.scrollPosition);
        });
      }
    },
    onClickClose() {
      this.windowService.closeFullscreenPopup();
    },
    onClickExpand(event, media) {
      const reviewIndex = this.reviews.findIndex(r => r.id === media.review.id);
      const url = this.reviewPopupUrl(
        media.review,
        media.media_position,
        reviewIndex,
        {
          sort: this.sort,
          with_media: true,
          media_summary_popup: true,
          ...(this.activeTab === 'video' ? { with_video: true } : {})
        }
      );
      this.windowService.openFullscreenPopup(url, event.currentTarget);
    },
    onChangeTab(tab) {
      this.SET_ACTIVE_TAB(tab);
      const params = { init: true };
      if (tab === 'video') params.with_video = true;
      this.fetchResource(params);
    },
    onIntersect() {
      if (this.isLoadingMediaReviewCollage) return;

      const params = { page: this.pagy.next };
      if (this.activeTab === 'video') params.with_video = true;
      this.fetchResource(params);
    }
  }
};
